export default __webpack_public_path__ + "static/media/Card.cd415937.svg";